import React from "react";
import MediaQuery from "react-responsive";
//
import Default from "./default";
import Mobile from "./mobile";
//
export default props => (
  <MediaQuery maxWidth={768}>
    {matches => {
      if (matches) return <Mobile {...props} />;
      return <Default {...props} />;
    }}
  </MediaQuery>
);
